import React from "react";

export const ModalButton = props =>
  <button class={props.className ? props.className : "btn btn-main"} data-toggle="modal" data-href={props.href ? props.href : "#modal"}>{props.label}</button>
